export const trainingThumbnailComponentsWhitelist = new Set([
  'ShortText',
]);
